import React, { PureComponent } from 'react';
import PT from 'prop-types';
import { ReactFormGroupWrapper } from './reactformgroupwrapper';

export class ReactFormFieldTextInput extends PureComponent{
    constructor(props) {
        super(props);
        
        this.handleInputChangeText = this.handleInputChangeText.bind(this);
        this.handleInputChangeInt = this.handleInputChangeInt.bind(this);
        this.handleInputChangeDecimal= this.handleInputChangeDecimal.bind(this);
    }

    handleInputChangeInt(e) {
        const regex = /^[0-9\b]+$/;
        const value = e.target.value;

        if (value === '') {
            this.props.onChange(value);
        }

        else if (regex.test(value))  {
            this.props.onChange(Number(value));
        }
    }

    handleInputChangeDecimal(e) {
        const value = e.target.value;
        if (!isNaN(value))
            this.props.onChange(value);
    }

    handleInputChangeText(e) {
        this.props.onChange(e.target.value);     
    }
    
    render() {
        let onChangeFunction;
        let type = "text";
        switch (this.props.type) {
            case "STRING":
                onChangeFunction = this.handleInputChangeText;
                break;
            case "INT":
                if(this.props.min && this.props.max && this.props.step) type = "number";
                onChangeFunction = this.handleInputChangeInt;
                break;
            case "DECIMAL":
                onChangeFunction = this.handleInputChangeDecimal;
                break;
            default:
                onChangeFunction = this.handleInputChangeText;
        }

        const SimpleTextFieldView = this.props.viewProvider.getSimpleTextFieldView();
        
        return (
            <ReactFormGroupWrapper {...this.props}>
                <SimpleTextFieldView 
                    name={this.props.name} value={this.props.value} 
                    min={this.props.min} max={this.props.max} maxlength={this.props.maxlength} 
                    step={this.props.step} readOnly={this.props.readOnly} 
                    onChange={(e) => onChangeFunction(e)} type={type} 
                    isRequired={this.props.isRequired} isInvalid={this.props.showValidationErrors} />
            </ReactFormGroupWrapper>
        );
    }
}

ReactFormFieldTextInput.propTypes = {
    name: PT.string,
    value: PT.any,
    min: PT.number,
    max: PT.number,
    step: PT.number,
    maxlength: PT.number,
    onChange: PT.func,
    readOnly: PT.bool,
    validationErrors: PT.array,
    showValidationErrors: PT.bool,
    type: PT.string,
    viewProvider: PT.object,
    isRequired: PT.bool,
    lang: PT.string
};

ReactFormFieldTextInput.defaultProps = {
    value: "",
    readOnly: false
};
